import { TranslationObject } from '../i18n/translation';

const namespace = 'toolbar';
const translations: TranslationObject = {
  iconButtonLabel: {
    id: `${namespace}.iconButtonLabel`,
    nb: 'Meny',
    en: 'Menu',
  },
};

export default translations;
